import {CategoryTypeVo} from '../../../common/shared/api/nicolas/vo/enums/CategoryTypeVo.enum';
import {isValidEnumValue} from '../../../common/shared/utils/isValidEnumValue';
import {
  SearchKeywordSortType,
  SearchThemeKeywordSortType,
} from '../../../graphql/generated/types';

/**
 * 검색 결과 페이지에서 사용되는 location.searchParam 인터페이스 입니다.
 */
export interface SearchKeywordSearchParam {
  keyword: string;
  showOnlyComplete?: string;
  sortType?: string;
  categoryUid?: string;
}

/**
 * 키워드 검색 쿼리의 필수 파라미터가 있는지 확인합니다.
 */
export function validateSearchKeywordSearchParam(
  value: any
): value is SearchKeywordSearchParam {
  return 'keyword' in value && value['keyword'] !== '';
}

export interface SearchThemeKeywordSearchParam {
  /** 테마키워드 필터는 ,로 구분됩니다. */
  filterList: string;
  sortType?: string;
}

export function validateSearchThemeKeywordSearchParam(
  value: any
): value is SearchThemeKeywordSearchParam {
  return 'filterList' in value && value['filterList'] !== '';
}

export function validateCategoryUid(value?: string) {
  const _value = Number(value);
  return (
    !!value &&
    !isNaN(Number(_value)) &&
    isValidEnumValue(CategoryTypeVo, _value)
  );
}

export function validateSearchKeywordSortType(
  value?: string
): value is SearchKeywordSortType {
  return (
    !!value &&
    !!Object.values(SearchKeywordSortType).find(type => type === value)
  );
}

export function validateSearchThemeKeywordSortType(
  value: string
): value is SearchThemeKeywordSortType {
  return (
    !!value &&
    !!Object.values(SearchThemeKeywordSortType).find(type => type === value)
  );
}
